import { call, put, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { fetchProjectsApi } from "../../API/API";

function* fetchProjectsSaga(params) {
  try {
    const response = yield call(fetchProjectsApi, params);
    yield put({
      type: types.FETCH_PROJECTS_SUCCESS,
      payload: {
        projects: response.data?.data?.projects || [],
        pagination: response.data?.data?.pagination || {},
      },
    });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECTS_FAILURE, error });
  }
}

export function* watchFetchProjectsSaga() {
  yield takeLatest(types.FETCH_PROJECTS_INIT, fetchProjectsSaga);
}
